module.exports = __webpack_public_path__ + "703a7eed3803db2e5308eae816d94bef.png";